import React from 'react'
import PropTypes from 'prop-types'
import EventImageAspectRatioContainer from 'components/EventImageAspectRatioContainer'

const EventCardBigContainer = ({ image, showOverlay, ...rest }) => (
  <EventImageAspectRatioContainer
    className="bg-cover rounded-lg w-full bg-center"
    style={{
      backgroundImage: showOverlay
        ? `linear-gradient(270deg, rgba(16, 19, 22, 0.0001) 0.37%, #101316 99.63%), url(${image})`
        : `url(${image})`,
    }}
    {...rest}
  />
)

EventCardBigContainer.propTypes = {
  image: PropTypes.string.isRequired,
  showOverlay: PropTypes.bool,
}

EventCardBigContainer.defaultProps = {
  showOverlay: true,
}

export default EventCardBigContainer
